import React from 'react';

// Components
import { Center, Grid } from '@wegroup/design-system';
import LabelValue from '../offers/LabelValue';
import { useTranslation } from 'react-i18next';
import InsuranceCompanyLogo from '../../../../common/src/components/InsuranceCompanyLogo';

interface Props {
  insuranceCompanyKey: string;
  insuranceCompanyName: string;
  insuranceName: string;
  contractStartDate: string;
  offerValidDate: string;
}

const SignedOfferGeneralInfo: React.FC<React.PropsWithChildren<Props>> = ({
  insuranceCompanyKey,
  insuranceCompanyName,
  insuranceName,
  contractStartDate,
  offerValidDate,
}) => {
  const { t } = useTranslation();

  return (
    <Grid
      templateColumns={{
        base: 'repeat(2, 1fr)',
        laptop: 'repeat(4, 1fr)',
      }}
      width="100%"
      gap={{ base: 6, laptop: 12 }}
      flexGrow={1}
    >
      <Center maxW="60" maxH="14">
        <InsuranceCompanyLogo insuranceCompany={insuranceCompanyKey} />
      </Center>
      <LabelValue label={insuranceCompanyName}>{insuranceName}</LabelValue>
      <LabelValue label={t('Desired contract start date')}>
        {contractStartDate}
      </LabelValue>
      <LabelValue label={t('This offer is valid until')}>
        {offerValidDate}
      </LabelValue>
    </Grid>
  );
};

export default SignedOfferGeneralInfo;
